import { render, staticRenderFns } from "./BookingDotCom.vue?vue&type=template&id=fae01d9c"
import script from "./BookingDotCom.vue?vue&type=script&lang=js"
export * from "./BookingDotCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports